import PropTypes from 'prop-types';
import { TRAITS } from 'lib/trait';

export default PropTypes.arrayOf(
  PropTypes.shape({
    type: PropTypes.oneOf(TRAITS),
  })
);
